import React from 'react';
import ModuleTopic from '../../components/ModuleTopic';

interface ITopicProps {
  settings: any;
}

const TopicAi: React.FunctionComponent<ITopicProps> = ({ settings }) => (
  <ModuleTopic settings={settings} moduleKey="ai" />
);

export default TopicAi;
